// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Invoice & Recover field system — Figma Input Field System 140:6947.
   This layer normalises native, MUI v4/v5 and shared application fields. */

:root {
  --field-height-sm: 32px;
  --field-height-md: 40px;
  --field-height-lg: 48px;
  --field-text-sm: 13px;
  --field-text-md: 14px;
  --field-text-lg: 16px;
  --field-label-sm: 12px;
  --field-label-md: 13px;
  --field-label-lg: 14px;
  --field-helper-sm: 11px;
  --field-helper-md: 12px;
  --field-helper-lg: 13px;
  --field-padding-sm: 10px;
  --field-padding-md: 12px;
  --field-padding-lg: 14px;
  --field-focus-ring: 0 0 0 3px rgba(15, 186, 196, 0.22);
}

:root {
  --field-focus-shadow: var(--field-focus-ring);
}

:where(input, textarea, .MuiInputBase-input, .MuiOutlinedInput-input) {
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: var(--field-text-md) !important;
  font-weight: var(--font-weight-regular, 400) !important;
  line-height: normal !important;
  letter-spacing: 0 !important;
}

:where(input, textarea, .MuiInputBase-input)::placeholder {
  color: var(--text-disabled, #8a9896) !important;
  font: inherit !important;
  opacity: 1 !important;
}

/* Native text-like controls only; semantic controls retain browser/application UI. */
:where(
    input:not([type]),
    input[type="text"],
    input[type="email"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    input[type="url"],
    input[type="number"],
    input[type="date"],
    input[type="time"],
    input[type="datetime-local"]
  ):not(.MuiInputBase-input),
:where(textarea):not(.MuiInputBase-input) {
  box-sizing: border-box;
  color: var(--text-primary, #142624);
  background: var(--surface-primary, #fff);
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  outline: 0;
  transition: border-color 120ms ease, background-color 120ms ease;
}

:where(
    input:not([type]),
    input[type="text"],
    input[type="email"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    input[type="url"],
    input[type="number"],
    input[type="date"],
    input[type="time"],
    input[type="datetime-local"]
  ):not(.MuiInputBase-input) {
  min-height: var(--field-height-md);
  padding: 0 var(--field-padding-md);
}

:where(textarea):not(.MuiInputBase-input) {
  min-height: 120px;
  padding: var(--field-padding-md);
  resize: vertical;
}

:where(input, textarea):not(.MuiInputBase-input):enabled:not([readonly]):hover {
  border-color: var(--border-strong, #aebab8);
}

:where(input, textarea):not(.MuiInputBase-input):focus-visible {
  border: 2px solid var(--interactive-default, #0f766e);
  box-shadow: var(--field-focus-shadow) !important;
}

:where(input, textarea):not(.MuiInputBase-input):is([aria-invalid="true"], .is-error, .error) {
  border-color: var(--danger-default, #c23a2b) !important;
}

:where(input, textarea):not(.MuiInputBase-input):disabled {
  color: var(--text-disabled, #8a9896) !important;
  -webkit-text-fill-color: var(--text-disabled, #8a9896) !important;
  background: var(--surface-secondary, #f4f7f7) !important;
  border-color: var(--border-subtle, #dce3e2) !important;
  cursor: not-allowed;
  opacity: 0.75;
}

/* Composite controls own their surface, border, radius and focus state. Their
   inner native control must stay visually transparent; otherwise a second
   outline appears inside search bars and editor field shells. */
:is(
    .ir-input-shell,
    .quotation-input-box,
    .quotation-item-search-box,
    .quotation-filter-search,
    .quotation-recipient-box,
    .rcti-list-search,
    .rcti-c04-search,
    .rcti-recipient-box,
    .contacts-search-box,
    .credit-note-search,
    .debit-search,
    .expenses-search,
    .recovery-search,
    .items-search,
    .credit-usage-search,
    .invoice-history-search,
    .invoice-filter-row > label,
    .invoice-creation-trigger-container,
    .app-topbar__search,
    .settings-password-input,
    .figma-datepicker__input-container,
    .send-input-box,
    .send-textarea-box,
    [data-field-container="true"]
  )
  :is(input, textarea, select):not(.MuiInputBase-input) {
  width: 100%;
  min-width: 0;
  min-height: 0 !important;
  height: 100%;
  padding: 0 !important;
  color: inherit;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

:is(
    .quotation-input-box,
    .quotation-item-search-box,
    .quotation-filter-search,
    .rcti-list-search,
    .rcti-c04-search,
    .contacts-search-box,
    .credit-note-search,
    .debit-search,
    .expenses-search,
    .recovery-search,
    .items-search,
    .credit-usage-search,
    .invoice-history-search,
    .invoice-filter-row > label,
    .invoice-creation-trigger-container,
    .app-topbar__search,
    .settings-password-input,
    .ir-input-shell,
    [data-field-container="true"]
  ):focus-within {
  border: 2px solid var(--interactive-default, #0f766e) !important;
  outline: 0 !important;
  box-shadow: var(--field-focus-shadow) !important;
}

/* Explicit Figma sizes for native and MUI controls. MD is the application default. */
:where(.inr-field--sm, [data-field-size="sm"]) :where(input, textarea),
:where(input, textarea):is(.inr-field--sm, [data-field-size="sm"]) {
  font-size: var(--field-text-sm) !important;
}

:where(.inr-field--sm, [data-field-size="sm"]) :where(input:not([type]), input:not([type="checkbox"]):not([type="radio"]), .MuiOutlinedInput-root),
:where(input):is(.inr-field--sm, [data-field-size="sm"]) {
  min-height: var(--field-height-sm);
}

:where(.inr-field--lg, [data-field-size="lg"]) :where(input, textarea),
:where(input, textarea):is(.inr-field--lg, [data-field-size="lg"]) {
  font-size: var(--field-text-lg) !important;
}

:where(.inr-field--lg, [data-field-size="lg"]) :where(input:not([type]), input:not([type="checkbox"]):not([type="radio"]), .MuiOutlinedInput-root),
:where(input):is(.inr-field--lg, [data-field-size="lg"]) {
  min-height: var(--field-height-lg);
}

:where(.inr-field--sm, [data-field-size="sm"]) textarea { min-height: 80px; }
:where(.inr-field--lg, [data-field-size="lg"]) textarea { min-height: 160px; }

/* MUI v4/v5 OutlinedInput and TextField. */
.MuiOutlinedInput-root {
  min-height: var(--field-height-md);
  color: var(--text-primary, #142624) !important;
  background: var(--surface-primary, #fff) !important;
  border-radius: var(--radius-md, 10px) !important;
  transition: background-color 120ms ease;
}

.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: var(--border-default, #cdd6d4) !important;
}

.MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):not(.Mui-focused) .MuiOutlinedInput-notchedOutline {
  border-color: var(--border-strong, #aebab8) !important;
}

.MuiOutlinedInput-root.Mui-focused:not(.Mui-error) {
  box-shadow: var(--field-focus-shadow) !important;
}

.MuiOutlinedInput-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline {
  border-color: var(--interactive-default, #0f766e) !important;
  border-width: 2px !important;
}

.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: var(--danger-default, #c23a2b) !important;
}

.MuiOutlinedInput-root.Mui-disabled {
  color: var(--text-disabled, #8a9896) !important;
  background: var(--surface-secondary, #f4f7f7) !important;
  opacity: 0.75;
}

.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
  border-color: var(--border-subtle, #dce3e2) !important;
}

.MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input {
  color: var(--text-disabled, #8a9896) !important;
  -webkit-text-fill-color: var(--text-disabled, #8a9896) !important;
}

.MuiOutlinedInput-input,
.MuiInputBase-input.MuiOutlinedInput-input {
  box-sizing: border-box !important;
  height: var(--field-height-md) !important;
  padding: 0 var(--field-padding-md) !important;
}

.MuiOutlinedInput-root.MuiInputBase-multiline {
  min-height: 120px;
  padding: 0 !important;
  align-items: flex-start;
}

.MuiOutlinedInput-root.MuiInputBase-multiline .MuiOutlinedInput-inputMultiline,
.MuiOutlinedInput-root.MuiInputBase-multiline textarea {
  min-height: 120px;
  padding: var(--field-padding-md) !important;
}

.MuiInputAdornment-root,
.MuiOutlinedInput-root .MuiSvgIcon-root {
  color: var(--text-secondary, #506360);
}

.MuiInputAdornment-root .MuiSvgIcon-root {
  width: 20px;
  height: 20px;
}

.MuiInputLabel-root,
.inr-field-label {
  color: var(--text-primary, #142624) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: var(--field-label-md) !important;
  font-weight: var(--font-weight-medium, 500) !important;
  line-height: normal !important;
  letter-spacing: 0 !important;
}

.MuiInputLabel-root.Mui-focused:not(.Mui-error) {
  color: var(--text-primary, #142624) !important;
}

.MuiInputLabel-root.Mui-error,
.MuiFormHelperText-root.Mui-error,
.inr-field-error {
  color: var(--danger-default, #c23a2b) !important;
}

.MuiInputLabel-root.Mui-disabled { color: var(--text-disabled, #8a9896) !important; }

.MuiFormHelperText-root,
.inr-field-helper,
.inr-field-error {
  margin: 6px 0 0 !important;
  color: var(--text-secondary, #506360);
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: var(--field-helper-md) !important;
  font-weight: var(--font-weight-regular, 400) !important;
  line-height: normal !important;
  letter-spacing: 0 !important;
}

.MuiFormLabel-asterisk,
.inr-field-required {
  color: var(--danger-default, #c23a2b) !important;
}

input[type="search"]::-webkit-search-cancel-button { cursor: pointer; }

@media (prefers-reduced-motion: reduce) {
  :where(input, textarea),
  .MuiOutlinedInput-root { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/form-fields.css"],"names":[],"mappings":"AAAA;2EAC2E;;AAE3E;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wEAAwE;EACxE,0CAA0C;EAC1C,uDAAuD;EACvD,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;EAC/C,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,qFAAqF;AACrF;;;;;;;;;;;;;;EAcE,sBAAsB;EACtB,mCAAmC;EACnC,wCAAwC;EACxC,gDAAgD;EAChD,qCAAqC;EACrC,UAAU;EACV,gEAAgE;AAClE;;AAEA;;;;;;;;;;;;;EAaE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,+CAA+C;EAC/C,iEAAiE;EACjE,wDAAwD;EACxD,sDAAsD;EACtD,mBAAmB;EACnB,aAAa;AACf;;AAEA;;gEAEgE;AAChE;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2BE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;;;;;;;;;;EAqBE,gEAAgE;EAChE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,qFAAqF;AACrF;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,0DAA0D,gBAAgB,EAAE;AAC5E,0DAA0D,iBAAiB,EAAE;;AAE7E,2CAA2C;AAC3C;EACE,kCAAkC;EAClC,8CAA8C;EAC9C,mDAAmD;EACnD,gDAAgD;EAChD,uCAAuC;AACzC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,4DAA4D;EAC5D,4BAA4B;AAC9B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,+CAA+C;EAC/C,wDAAwD;EACxD,aAAa;AACf;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,+CAA+C;EAC/C,iEAAiE;AACnE;;AAEA;;EAEE,iCAAiC;EACjC,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,8CAA8C;EAC9C,wEAAwE;EACxE,2CAA2C;EAC3C,sDAAsD;EACtD,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA,mCAAmC,+CAA+C,EAAE;;AAEpF;;;EAGE,0BAA0B;EAC1B,qCAAqC;EACrC,wEAAwE;EACxE,4CAA4C;EAC5C,uDAAuD;EACvD,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA,qDAAqD,eAAe,EAAE;;AAEtE;EACE;2BACyB,gBAAgB,EAAE;AAC7C","sourcesContent":["/* Invoice & Recover field system — Figma Input Field System 140:6947.\n   This layer normalises native, MUI v4/v5 and shared application fields. */\n\n:root {\n  --field-height-sm: 32px;\n  --field-height-md: 40px;\n  --field-height-lg: 48px;\n  --field-text-sm: 13px;\n  --field-text-md: 14px;\n  --field-text-lg: 16px;\n  --field-label-sm: 12px;\n  --field-label-md: 13px;\n  --field-label-lg: 14px;\n  --field-helper-sm: 11px;\n  --field-helper-md: 12px;\n  --field-helper-lg: 13px;\n  --field-padding-sm: 10px;\n  --field-padding-md: 12px;\n  --field-padding-lg: 14px;\n  --field-focus-ring: 0 0 0 3px rgba(15, 186, 196, 0.22);\n}\n\n:root {\n  --field-focus-shadow: var(--field-focus-ring);\n}\n\n:where(input, textarea, .MuiInputBase-input, .MuiOutlinedInput-input) {\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: var(--field-text-md) !important;\n  font-weight: var(--font-weight-regular, 400) !important;\n  line-height: normal !important;\n  letter-spacing: 0 !important;\n}\n\n:where(input, textarea, .MuiInputBase-input)::placeholder {\n  color: var(--text-disabled, #8a9896) !important;\n  font: inherit !important;\n  opacity: 1 !important;\n}\n\n/* Native text-like controls only; semantic controls retain browser/application UI. */\n:where(\n    input:not([type]),\n    input[type=\"text\"],\n    input[type=\"email\"],\n    input[type=\"password\"],\n    input[type=\"search\"],\n    input[type=\"tel\"],\n    input[type=\"url\"],\n    input[type=\"number\"],\n    input[type=\"date\"],\n    input[type=\"time\"],\n    input[type=\"datetime-local\"]\n  ):not(.MuiInputBase-input),\n:where(textarea):not(.MuiInputBase-input) {\n  box-sizing: border-box;\n  color: var(--text-primary, #142624);\n  background: var(--surface-primary, #fff);\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  outline: 0;\n  transition: border-color 120ms ease, background-color 120ms ease;\n}\n\n:where(\n    input:not([type]),\n    input[type=\"text\"],\n    input[type=\"email\"],\n    input[type=\"password\"],\n    input[type=\"search\"],\n    input[type=\"tel\"],\n    input[type=\"url\"],\n    input[type=\"number\"],\n    input[type=\"date\"],\n    input[type=\"time\"],\n    input[type=\"datetime-local\"]\n  ):not(.MuiInputBase-input) {\n  min-height: var(--field-height-md);\n  padding: 0 var(--field-padding-md);\n}\n\n:where(textarea):not(.MuiInputBase-input) {\n  min-height: 120px;\n  padding: var(--field-padding-md);\n  resize: vertical;\n}\n\n:where(input, textarea):not(.MuiInputBase-input):enabled:not([readonly]):hover {\n  border-color: var(--border-strong, #aebab8);\n}\n\n:where(input, textarea):not(.MuiInputBase-input):focus-visible {\n  border: 2px solid var(--interactive-default, #0f766e);\n  box-shadow: var(--field-focus-shadow) !important;\n}\n\n:where(input, textarea):not(.MuiInputBase-input):is([aria-invalid=\"true\"], .is-error, .error) {\n  border-color: var(--danger-default, #c23a2b) !important;\n}\n\n:where(input, textarea):not(.MuiInputBase-input):disabled {\n  color: var(--text-disabled, #8a9896) !important;\n  -webkit-text-fill-color: var(--text-disabled, #8a9896) !important;\n  background: var(--surface-secondary, #f4f7f7) !important;\n  border-color: var(--border-subtle, #dce3e2) !important;\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n\n/* Composite controls own their surface, border, radius and focus state. Their\n   inner native control must stay visually transparent; otherwise a second\n   outline appears inside search bars and editor field shells. */\n:is(\n    .ir-input-shell,\n    .quotation-input-box,\n    .quotation-item-search-box,\n    .quotation-filter-search,\n    .quotation-recipient-box,\n    .rcti-list-search,\n    .rcti-c04-search,\n    .rcti-recipient-box,\n    .contacts-search-box,\n    .credit-note-search,\n    .debit-search,\n    .expenses-search,\n    .recovery-search,\n    .items-search,\n    .credit-usage-search,\n    .invoice-history-search,\n    .invoice-filter-row > label,\n    .invoice-creation-trigger-container,\n    .app-topbar__search,\n    .settings-password-input,\n    .figma-datepicker__input-container,\n    .send-input-box,\n    .send-textarea-box,\n    [data-field-container=\"true\"]\n  )\n  :is(input, textarea, select):not(.MuiInputBase-input) {\n  width: 100%;\n  min-width: 0;\n  min-height: 0 !important;\n  height: 100%;\n  padding: 0 !important;\n  color: inherit;\n  background: transparent !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n\n:is(\n    .quotation-input-box,\n    .quotation-item-search-box,\n    .quotation-filter-search,\n    .rcti-list-search,\n    .rcti-c04-search,\n    .contacts-search-box,\n    .credit-note-search,\n    .debit-search,\n    .expenses-search,\n    .recovery-search,\n    .items-search,\n    .credit-usage-search,\n    .invoice-history-search,\n    .invoice-filter-row > label,\n    .invoice-creation-trigger-container,\n    .app-topbar__search,\n    .settings-password-input,\n    .ir-input-shell,\n    [data-field-container=\"true\"]\n  ):focus-within {\n  border: 2px solid var(--interactive-default, #0f766e) !important;\n  outline: 0 !important;\n  box-shadow: var(--field-focus-shadow) !important;\n}\n\n/* Explicit Figma sizes for native and MUI controls. MD is the application default. */\n:where(.inr-field--sm, [data-field-size=\"sm\"]) :where(input, textarea),\n:where(input, textarea):is(.inr-field--sm, [data-field-size=\"sm\"]) {\n  font-size: var(--field-text-sm) !important;\n}\n\n:where(.inr-field--sm, [data-field-size=\"sm\"]) :where(input:not([type]), input:not([type=\"checkbox\"]):not([type=\"radio\"]), .MuiOutlinedInput-root),\n:where(input):is(.inr-field--sm, [data-field-size=\"sm\"]) {\n  min-height: var(--field-height-sm);\n}\n\n:where(.inr-field--lg, [data-field-size=\"lg\"]) :where(input, textarea),\n:where(input, textarea):is(.inr-field--lg, [data-field-size=\"lg\"]) {\n  font-size: var(--field-text-lg) !important;\n}\n\n:where(.inr-field--lg, [data-field-size=\"lg\"]) :where(input:not([type]), input:not([type=\"checkbox\"]):not([type=\"radio\"]), .MuiOutlinedInput-root),\n:where(input):is(.inr-field--lg, [data-field-size=\"lg\"]) {\n  min-height: var(--field-height-lg);\n}\n\n:where(.inr-field--sm, [data-field-size=\"sm\"]) textarea { min-height: 80px; }\n:where(.inr-field--lg, [data-field-size=\"lg\"]) textarea { min-height: 160px; }\n\n/* MUI v4/v5 OutlinedInput and TextField. */\n.MuiOutlinedInput-root {\n  min-height: var(--field-height-md);\n  color: var(--text-primary, #142624) !important;\n  background: var(--surface-primary, #fff) !important;\n  border-radius: var(--radius-md, 10px) !important;\n  transition: background-color 120ms ease;\n}\n\n.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-color: var(--border-default, #cdd6d4) !important;\n}\n\n.MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):not(.Mui-focused) .MuiOutlinedInput-notchedOutline {\n  border-color: var(--border-strong, #aebab8) !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused:not(.Mui-error) {\n  box-shadow: var(--field-focus-shadow) !important;\n}\n\n.MuiOutlinedInput-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline {\n  border-color: var(--interactive-default, #0f766e) !important;\n  border-width: 2px !important;\n}\n\n.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {\n  border-color: var(--danger-default, #c23a2b) !important;\n}\n\n.MuiOutlinedInput-root.Mui-disabled {\n  color: var(--text-disabled, #8a9896) !important;\n  background: var(--surface-secondary, #f4f7f7) !important;\n  opacity: 0.75;\n}\n\n.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {\n  border-color: var(--border-subtle, #dce3e2) !important;\n}\n\n.MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input {\n  color: var(--text-disabled, #8a9896) !important;\n  -webkit-text-fill-color: var(--text-disabled, #8a9896) !important;\n}\n\n.MuiOutlinedInput-input,\n.MuiInputBase-input.MuiOutlinedInput-input {\n  box-sizing: border-box !important;\n  height: var(--field-height-md) !important;\n  padding: 0 var(--field-padding-md) !important;\n}\n\n.MuiOutlinedInput-root.MuiInputBase-multiline {\n  min-height: 120px;\n  padding: 0 !important;\n  align-items: flex-start;\n}\n\n.MuiOutlinedInput-root.MuiInputBase-multiline .MuiOutlinedInput-inputMultiline,\n.MuiOutlinedInput-root.MuiInputBase-multiline textarea {\n  min-height: 120px;\n  padding: var(--field-padding-md) !important;\n}\n\n.MuiInputAdornment-root,\n.MuiOutlinedInput-root .MuiSvgIcon-root {\n  color: var(--text-secondary, #506360);\n}\n\n.MuiInputAdornment-root .MuiSvgIcon-root {\n  width: 20px;\n  height: 20px;\n}\n\n.MuiInputLabel-root,\n.inr-field-label {\n  color: var(--text-primary, #142624) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: var(--field-label-md) !important;\n  font-weight: var(--font-weight-medium, 500) !important;\n  line-height: normal !important;\n  letter-spacing: 0 !important;\n}\n\n.MuiInputLabel-root.Mui-focused:not(.Mui-error) {\n  color: var(--text-primary, #142624) !important;\n}\n\n.MuiInputLabel-root.Mui-error,\n.MuiFormHelperText-root.Mui-error,\n.inr-field-error {\n  color: var(--danger-default, #c23a2b) !important;\n}\n\n.MuiInputLabel-root.Mui-disabled { color: var(--text-disabled, #8a9896) !important; }\n\n.MuiFormHelperText-root,\n.inr-field-helper,\n.inr-field-error {\n  margin: 6px 0 0 !important;\n  color: var(--text-secondary, #506360);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: var(--field-helper-md) !important;\n  font-weight: var(--font-weight-regular, 400) !important;\n  line-height: normal !important;\n  letter-spacing: 0 !important;\n}\n\n.MuiFormLabel-asterisk,\n.inr-field-required {\n  color: var(--danger-default, #c23a2b) !important;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button { cursor: pointer; }\n\n@media (prefers-reduced-motion: reduce) {\n  :where(input, textarea),\n  .MuiOutlinedInput-root { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
